module.exports = __webpack_public_path__ + "static/media/typescript-original.56652d34.svg";